import type { FunnelStep } from '@crosscastr/shared';
import { Icon, type IconName } from './Icon.js';
import { fmt } from '../lib/format.js';

const STEP_ICON: Record<FunnelStep['key'], IconName> = { sent: 'send', delivered: 'checkDouble', read: 'eye' };
const STEP_BG: Record<FunnelStep['key'], string> = {
  sent: 'linear-gradient(90deg, var(--teal-700), var(--teal-500))',
  delivered: 'linear-gradient(90deg, var(--teal-600), var(--teal-300))',
  read: 'linear-gradient(90deg, var(--green-600), var(--green-500))',
};

/**
 * Broadcast funnel sent → delivered → read (DESIGN.md §5). Descending horizontal bars that fill
 * from the RTL start (right), mono counts + %, drop-off caption between steps. Reused on the
 * dashboard and per-campaign analytics.
 */
export function Funnel({ steps }: { steps: FunnelStep[] }): JSX.Element {
  const sent = steps.find((s) => s.key === 'sent')?.count ?? 0;
  const delivered = steps.find((s) => s.key === 'delivered')?.count ?? 0;
  const read = steps.find((s) => s.key === 'read')?.count ?? 0;
  const notDelivered = sent - delivered;
  const notDelivPct = sent ? ((notDelivered / sent) * 100).toFixed(1) : '0';
  const readOfDeliv = delivered ? Math.round((read / delivered) * 100) : 0;

  return (
    <div className="steps">
      {steps.map((s, i) => (
        <div key={s.key}>
          <div className="fstep">
            <div className={`bar${s.key === 'sent' ? ' sheen-host sheen-once' : ''}`} style={{ width: `${Math.max(s.pct, 42)}%`, background: STEP_BG[s.key] }}>
              <span className="lbl"><Icon name={STEP_ICON[s.key]} /> {s.label}</span>
              <span className="val">{fmt(s.count)}<small>{s.pct}%</small></span>
            </div>
          </div>
          {i === 0 && (
            <div className="drop">↓ ‎-{notDelivPct}% · {fmt(notDelivered)} לא הגיעו</div>
          )}
          {i === 1 && (
            <div className="drop">↓ {readOfDeliv}% נקראו מתוך שהגיעו</div>
          )}
        </div>
      ))}
    </div>
  );
}
